import { createFileRoute, Navigate } from "@tanstack/react-router";
import type { FermentationGroupId } from "@brewbase/db/types";
import { FermentationStatusEnum } from "@brewbase/db/types";
import { trpc } from "@/hooks/trpc";
import { DEFAULT_SECTION_BY_STATUS } from "@/features/fermentation-journal/constants";

export const Route = createFileRoute("/fermentations/$group_id/")({
  component: IndexRedirect,
});

function IndexRedirect() {
  const groupId = Route.useParams().group_id as unknown as FermentationGroupId;

  // Fetch group to determine status
  const { data: group } = trpc.fermentations.groups.getWithAllDetails.useQuery(groupId);

  // Get default section based on status
  const status = group?.fermentations[0]?.status ?? FermentationStatusEnum.PLANNED;
  const defaultSection = DEFAULT_SECTION_BY_STATUS[status];

  return <Navigate to={`/fermentations/$group_id/${defaultSection}` as any} params={{ group_id: groupId } as any} replace />;
}

